
const Spacer = () => {
    return <div style={{flexGrow: 1}}/>
}

export {Spacer}